import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import {Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import $ from 'jquery';
import 'datatables.net';
import {style} from "variables/Variables.jsx";
import "../assets/css/datatables/datatables.min.css";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import {confirmAlert} from 'react-confirm-alert';
import NotificationSystem from "react-notification-system";
import SimpleReactValidator from 'simple-react-validator';
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import ReactTooltip from 'react-tooltip';
import Select from 'react-select';
import { List } from 'react-virtualized';
import DatePicker from "react-datepicker";
import jwt_decode from "jwt-decode";
import Switch from "react-switch";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import ModalD from "react-awesome-modal";
import imgNobody from '../assets/img/faces/nobody_m.original.jpg';
import * as moment from "moment";
import Dropzone from 'react-dropzone';
import usersSample from '../assets/usersSample.xlsx';
const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function titleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
}
function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}
var timestamp  = new Date().getTime();
class UserList extends Component {
    constructor(props) {
        super(props);
        this.state = {
        group_select: true,
        users: [],
        user_admin_access: false,
        user_approval_access: false,
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        password: '',
        confirm_password: '',
        userType: '',
        is_active:'',
        contact_title:'',
        address:'',
        lastAccess:null,
        startDate:'',
        userGroup: '',
        userSubGroup: '',
        organization: '',
        filterOrganization: '',
        organizationName: '',
        designation:'',
        extra_data:null,
        selectedFile: null,
        newUserModel: false,
        newInfoModel: false,
        editUserModel: false,
        loading: false,
        sending:false,
        _notificationSystem: null,
        userGroups: [],
        login_type: 'Standard',
        epassword: '',
        ecpassword: '',
        userSubGroups: [],
        organizationList: [],
        object_type: '',
        object_code:'',
        updated_by:'',
        created_by:'',
        account_expiry_date: '',
        approve:[],
        action_type:'',
        edit_user_id:'',
        logged_user_type:'',
        edit_file:null,
        auth_type:'',
        send_mail: false,
        newOrgModel: false,
        all_orgs:'',
        merchant_id:[],
        chain_id:[],
        store_code:[],
        logged_object_type:'',
        last_logged_on:null,
        desigEditBox:false,
        authEditBox:false,
        isChange: false,
        filter_userType:'',
        userFilterGroup:'',
        is_org_loading: true,
        organizationFilterList:[],
        orgnization_codes:'',
        disableInput: false,
        model_visible : false,
        file_url: '',
        rfile: '',
        orgListOpen: false,
        orgHeaderTitle: "Select [Organization]",
        orgObject:[],
        user_upload: false,
        usersFiles:[],
        usersFilesDoc:[],
        usersFilesDocName:'',
        usersFilesName:'',
        uploaded_users_file_status:'No file chosen',
        files:[],
        upload_loading:false,
        edit_req:false,
        delete_req:false,
        statusLists:[{value:'active', label: 'Active'},{value:'inactive', label: 'Inactive'},{value:'pending_approval', label: 'Pending approval'}],
        statusValue:'',
        user_status:'',
        edited_by:'',
        password_edited :'',
        userSubGroupName:'',
        selectedFileName:'',
        is_user_approval_access: false,
        tableau_username:[],
        tableau_server:"",
        tablueUserName:"",
        departmentLists:[],
        user_department:'',
        is_refund_enable:false,
        is_refund_enable_lists:[]
    };
        this.closeOrgList = this.closeOrgList.bind(this);
    }

    componentWillMount() {
        this.validator = new SimpleReactValidator();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        let is_doc_upload = true;
        if(decoded.userGroupName==='Innoviti' && decoded.userSubGroupName==='Admin'){
            is_doc_upload = false;
        }

        this.setState({
            updated_by: decoded.email,
            created_by: decoded.email,
            luser_type: decoded.userType,
            lsub_group: decoded.userSubGroupName,
            is_doc_upload: is_doc_upload,
            is_user_approval_access: decoded.user_approval_access
        })
        if(decoded.userType=='External'){
            var orgnList = [];
            var stringCode = decoded.object_code;
            var arrayCode = stringCode.split(",");
            var orgn = decoded.user_info.organization;
            var arrayCodeorg = orgn.split(",");

            arrayCode.map((value, index) => {
                orgnList.push({value: value, label: arrayCodeorg[index]})
            })
            this.setState({
                userType: 'External',
                logged_user_type: decoded.userType,
                //userGroups : [{"group_id":decoded.userGroup, "user_type":decoded.userType,"group_name":decoded.userGroupName}],
                userGroup: decoded.userGroup,
                organization: orgnList,
                organizationList: orgnList,
                organizationFilterList: orgnList,
                organizationName: decoded.user_info.organization,
                logged_object_type: decoded.object_type,
                object_code: arrayCode,
                is_org_loading:false,
            })
            this.findSubGroups(decoded.userGroup,'');
        }
        else {
            this.setState({
                logged_user_type: decoded.userType,
            })
        }

    }
    componentDidUpdate() {
        const { orgListOpen } = this.state;
        console.log("storeListOpen", orgListOpen);
        setTimeout(() => {
            if (orgListOpen) {
                window.addEventListener('click', this.closeOrgList);
            } else {
                window.removeEventListener('click', this.closeOrgList);
            }
        }, 0);
    }
    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        if(decoded.object_type=='Merchant'){
            this.find_merchant_and_chain(arrayCode);

            this.findGroups('External','')
            this.get_codes_by_merchant(decoded.object_code)
        }
        else if(decoded.object_type=='Chain'){
            this.find_chain_id(arrayCode);
            this.findGroups('External', '')
            this.get_codes_by_chain(decoded.object_code)
        }
        else if(decoded.object_type=='Store'){
            this.setState({
                store_code:arrayCode
            })
            this.findGroups('External','')
            var orgns = decoded.user_info.organization;
            var arrayCodeorg = orgns.split(",");
            this.state.external_users = arrayCodeorg
            this._refreshUsers(arrayCodeorg);
        }
        else {
            this._refreshUsers();
        }
        this.get_config();
        this.get_department();
    }

    get_config(){
        axios.post(config.get('API_URL') + '/tableau/get-tableau-config/', {

            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
               let tuser = response.data.tableau_username;
               let array = this.state.tableau_username;
               if(tuser!='') {

                    array = tuser.split(',');
               }

               this.setState({
                    tableau_username: array,
                    tableau_server: response.data.tableau_server,
               })

        });
    }

    get_department(){
        axios.post(config.get('API_URL') + '/users/userdepartment/', {

            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
               this.setState({
                    departmentLists: response.data,

               })

        });
    }
    find_merchant_and_chain(val){
        axios.post(config.get('API_URL') + '/users/merchant_and_chain/', {

                merchant_code: val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            // console.log(response.data);
            //     alert(response.data.mids);
            this.setState({
                merchant_id: response.data.merchant_id,
                chain_id:response.data.chain_id
            })

        });
    }
    find_chain_id(val){
        axios.post(config.get('API_URL') + '/users/get_chain_id/', {
                chain_code: val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            // console.log(response.data);
            // alert(response.data.mids);
            this.setState({
                //merchant_id: response.data.merchant_id,
                chain_id:response.data.chain_id
            })

        });
    }
    get_codes_by_merchant(codes) {
        var data = {
            merchant_code:codes
        }
        axios.post(config.get('API_URL') + '/users/gets-code-by-merchant/', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            this.state.external_users = response.data
            this._refreshUsers(response.data);
        })
    }

    get_codes_by_chain(codes) {
        var data = {
            chain_code:codes
        }
        axios.post(config.get('API_URL') + '/users/gets-code-by-chain/', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            this.state.external_users = response.data
            this._refreshUsers(response.data);
        })
    }

    componentWillUnmount() {

    }
    change_user_admin_access(user_admin_access, e) {
        this.setState({
            user_admin_access:user_admin_access
        });
    }
    change_user_approval_access(user_approval_access, e) {
        this.setState({
            user_approval_access:user_approval_access
        });
    }
    onChangeInput(e) {
        this.setState({ [e.target.name]: e.target.value });
    }
    onChangeInputPhone(e) {
        this.setState({ [e.target.name]: (e.target.validity.valid) ? e.target.value :this.state.phone });


    }
    handleFromChange = date => {
        this.setState({
            account_expiry_date: date
        });
    };

    getFileExtension(filename) {
        return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    }

    onChangeHandler=event=>{
        var file = event.target.files[0];
        console.log(file);
        var ext = this.getFileExtension(file.name);
        this.setState({
            selectedFile: file,
            selectedFileName:file.name
        });
        // if(ext=='xlsx' || ext=='xls') {
        //     this.setState({
        //         selectedFile: file
        //     });
        // } else{
        //     this.props.handleClick("tr", 3, "Please upload valid file");
        //     this.setState({
        //         selectedFile: file
        //     });
        // }

    };
    changeFilterUserType(e) {
        this.setState({
            filter_userType : e.target.value,
            orgnization_codes:'',
            filterOrganization:[],
            isChange: true
        })
        if(e.target.value!=""){
            this.findGroups(e.target.value, 'edit');
            this.setState({
                userGroups:[]
            })
        }

    }

    changeUserType(e) {
        this.setState({
            userType : e.target.value,
            filter_userType : e.target.value,
            orgnization_codes:'',
            filterOrganization:[],
        })
        if(e.target.value!=""){
            this.findGroups(e.target.value, 'add');
        }

        if(e.target.value=='External') {
            this.setState({
                auth_type :''
            })
        }
        else{
            this.setState({
                auth_type :'Google'
            })
        }
    }
    changeUserFilterGroups(e){
        this.setState({
            userFilterGroup : e.target.value,
            orgnization_codes:'',
            filterOrganization: [],
            isChange: true
        })

        this.findFilterOrganization(e.target.options[e.target.selectedIndex].text, this.state.userType);

    }
    changeUserGroups(group_id, group_name, e){

        if(group_id===''){
            group_id = e.target.value;
            group_name = e.target.options[e.target.selectedIndex].text
        }
        this.setState({
            userGroup : group_id,
            orgObject: [],
            object_code:[],
            organizationName: '',
            is_refund_enable_lists:[]
        })
        this.findSubGroups(group_id,'default_load');
        this.findOrganization(group_name, this.state.userType, false, '','');
        this.setState({
            object_type: group_name
        })
    }

    changeTableauUser(e){
        this.setState({
            tablueUserName:e.target.value
        })
    }
    changeUserStatus(optionSelected){
        let value='';
        let staArray = [];
        if(optionSelected.length<1){
            value = null;
            staArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                staArray.push(mids.value)

            });

        }


        this.setState({
            user_status:staArray,
            statusValue:optionSelected,
            isChange: true,

        });

    }
    changeUserSubGroups(e){

        if(this.state.lsub_group != 'Admin'){
            if(e.target.options[e.target.selectedIndex].text==='Admin' || e.target.value==='1'){
                this.props.handleClick("tr", 3, "You are not allowed to add Admin users");
                return false;
            }
        }
        if(e.target.options[e.target.selectedIndex].text==='Refund Module Admin' || e.target.options[e.target.selectedIndex].text==='Refund Module Admin With Reports' || e.target.options[e.target.selectedIndex].text==='Refund Module Operator' || e.target.options[e.target.selectedIndex].text==='Refund Module Operator With Reports')
        {
            if(this.state.object_code!=""){
                setTimeout(function(){
                 this.checkRefundModuleStatus()
            }.bind(this), 200);
            }

        } else {
            this.setState({
                is_refund_enable_lists:[]
            })
        }


        this.setState({
            userSubGroup : e.target.value,
            userSubGroupName: e.target.options[e.target.selectedIndex].text
        })
        if(e.target.options[e.target.selectedIndex].text==='GENIE Sales Team' && this.state.userType==='Internal')
        {
            this.findOrganization('Store', 'External', false, '','');
            this.setState({
                object_code:[],
                organizationName:[],
                object_type: 'Store'
            })
        } else if(e.target.options[e.target.selectedIndex].text!=='GENIE Sales Team' && this.state.userType==='Internal')
        {
            this.setState({
                object_code:'Innoviti',
                organizationName: 'Innoviti',
                object_type: 'Innoviti'
            })
        }
    }
    changeTitle(e) {
        this.setState({
            contact_title : e.target.value
        })
    }
    toggleNewUserModel(modal_type) {
        //this.findGroups('External')
        this.validator.hideMessages();
        this.clearForm();
        this.setState({
            newUserModel: !this.state.newUserModel,
            action_type: 'Add New User',
            disableInput: false,
            is_refund_enable_lists:[]

        })
    }
    toggleInfoUserModel(modal_type) {
        // this.validator.hideMessages();
        this.clearForm();
        this.setState({
            newInfoModel: !this.state.newInfoModel,
            action_type: 'User Information'
        })
    }
    toggleNewUserUpload(){
        this.setState({
            user_upload: true
        })
    }
    closeUploadModal(){
        this.setState({
            user_upload: false
        })
    }
    onPreviewDropUsers=event=>{
        var file = event.target.files[0];
        var ext = this.getFileExtension(file.name);
         if(ext=='xlsx' || ext=='xls') {
             this.setState({
                usersFiles: file,
                usersFilesName: file.name
             });
         } else{
             this.props.handleClick("tr", 3, "Please upload valid file");
             this.setState({
                usersFiles: file
             });
         }

    };
    onPreviewDropUsersDoc=event=>{
        var fileDoc = event.target.files[0];
        var ext = this.getFileExtension(fileDoc.name);

        this.setState({
        usersFilesDoc: fileDoc,
        usersFilesDocName: fileDoc.name
        });
    };

    importUsers(e) {

        if(this.state.usersFilesName===''){
            this.props.handleClick("tr", 3, "Please upload valid file");
            return false;
        }

        if(this.state.lsub_group != 'Admin'){
            if(this.state.usersFilesDocName===''){
                this.props.handleClick("tr", 3, "Please upload Onboarding Document");
                return false;
            }
        }
        this.setState({
            upload_loading:true
        })
        var data = new FormData();
        data.append('uploaded_by', this.state.created_by);
        data.append('file', this.state.usersFiles);
        data.append('fileDoc', this.state.usersFilesDoc);
        data.append('is_doc_upload', this.state.is_doc_upload);
        axios.post(config.get('API_URL')+"/users/import_users/", data,{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        })
            .then((response) => {
                //console.log(response.data.error)
                if(response.data.error===null || response.data.error==='null') {
                    this.props.handleClick("tr", 1, "Record has been successfully Added.");
                       this._refreshUsers();
                }
                else {
                    this.props.handleClick("tr", 3, response.data.error.error+' '+response.data.error.error);
                }
                this.setState({
                    upload_loading:false
                })
                this.closeUploadModal();
            })
            .catch(function (error) {

                console.log("Res : " + error);
            });

    }
    clearForm(){
        if(this.state.logged_user_type=='Internal') {
            this.setState({
                group_select: true,
                user_admin_access: false,
                user_approval_access: false,
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                password: '',
                confirm_password: '',
                userType: '',
                is_active:'',
                contact_title:'',
                startDate:'',
                // userGroup: '',
                // userSubGroup: '',
                organization: [],
                organizationName: '',
                designation:'',
                extra_data:null,
                selectedFile: null,
                userGroups: [],
                login_type: 'Standard',
                auth_type: '',
                epassword: '',
                ecpassword: '',
                userSubGroups: [],
                organizationList: [],
                object_type: '',
                object_code:'',
                account_expiry_date: '',
                action_type:'',
                edit_user_id:'',
                orgObject:[]
            })
        } else {
            this.setState({
                group_select: true,
                user_admin_access: false,
                user_approval_access: false,
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                password: '',
                confirm_password: '',
                is_active:'',
                contact_title:'',
                startDate:'',
                userSubGroup: '',
                designation:'',
                organization: [],
                extra_data:null,
                selectedFile: null,
                login_type: 'Standard',
                auth_type: '',
                epassword: '',
                ecpassword: '',
                account_expiry_date: '',
                action_type:'',
                edit_user_id:'',
                orgObject:[],
                is_refund_enable_lists:[]
            })
        }

    }
    addUser() {

        var email_id = this.state.email.trim();
        if(this.state.userType=='Internal') {

            if (email_id.indexOf("@innoviti.com", email_id.length - "@innoviti.com".length) !== -1) {
                //VALID
            } else {
                this.props.handleClick("tr", 3, "Please Enter Innoviti Email");
                return false;
            }
        }
        var phone = this.state.phone.replace(/[^0-9]/g, '');
        if(phone.length >0) {
            if (phone.length != 10) {
                this.props.handleClick("tr", 3, "Phone number should 10 digit");
                return false;
            }
        }
        if(this.state.object_type=='Merchant' || this.state.object_type=='Chain' || this.state.object_type=='Store') {
            if (this.state.object_code=='') {
                this.props.handleClick("tr", 3, "Please Select Organization");
                return false;
            }
        }
        if(this.state.lsub_group != 'Admin'){
            if(this.state.userSubGroupName==='Admin' || this.state.userSubGroup==='1'){
                this.props.handleClick("tr", 3, "You are not allowed to add Admin users");
                return false;
            }
            if(this.state.selectedFileName==='' && this.state.userType=='External'){
                this.props.handleClick("tr", 3, "Please upload Onboarding Document");
                return false;
            }

        }
         if(this.state.userSubGroupName==='Refund Module Admin' || this.state.userSubGroupName==='Refund Module Admin With Reports' || this.state.userSubGroupName==='Refund Module Operator' || this.state.userSubGroupName==='Refund Module Operator With Reports')
        {
            if(this.state.is_refund_enable===false){
                this.props.handleClick("tr", 3, "Refund Module is not Enabled for given Merchant");
                return false;
            }
        }
        // console.log(this.validator);
        if (this.validator.allValid()) {

            const data = new FormData();
            data.append('file', this.state.selectedFile);
            data.append('firstName', titleCase(this.state.firstName));
            data.append('lastName', titleCase(this.state.lastName));
            data.append('email', (this.state.email).trim());
            data.append('phone', this.state.phone);
            data.append('loginType', this.state.login_type);
            data.append('userType', this.state.userType);
            data.append('userGroup', this.state.userGroup);
            data.append('userSubGroup', this.state.userSubGroup);
            data.append('password', this.state.password);
            data.append('extra_data', this.state.extra_data);
            data.append('pass_exp', true);
            data.append('contact_title', this.state.contact_title);
            data.append('api_key', 'gTrk2cJYgLtzDp2PBJ05b6Bczm3jbuR82VzvzOBehys=');
            data.append('user_admin_access', this.state.user_admin_access);
            data.append('user_approval_access', this.state.user_approval_access);
            data.append('objectType', this.state.object_type);
            data.append('objectCode', this.state.object_code);
            data.append('designation', this.state.designation);
            data.append('created_by', this.state.created_by);
            data.append('updated_by', this.state.updated_by);
            data.append('organizationName', this.state.organizationName);
            data.append('authType', this.state.auth_type);
            data.append('account_expiry_date', this.state.account_expiry_date);
            data.append('tablueUserName', this.state.tablueUserName);
            data.append('user_department', this.state.user_department);

            axios.post(config.get('API_URL') + '/users/register/', data, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                // console.log("abbaba")
                // console.log(response);
                if (response.data.error) {
                    this.props.handleClick("tr", 3, "Something went wrong");
                } else {
                    this._refreshUsers();
                    this.props.handleClick("tr", 1, "Record has been successfully Added.");
                    this.setState({
                        newUserModel: false,

                    });
                    this.clearForm()
                }
            }).catch(err => {
                this.props.handleClick("tr", 3, err.response.data.error);

                //console.log(err.error);

            });
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
        }
    }
    approveUser() {
        var data1 = {
            uid: this.state.edit_user_id,
            logged_uid: this.state.updated_by,
        }
        axios.post(config.get('API_URL') + '/users/approve_user/', data1, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {

            //console.log(response);
            if (response.data.error) {
                this.props.handleClick("tr", 3, response.data.error);
            } else {
                this._refreshUsers();
                this.props.handleClick("tr", 1, "User has been successfully approved.");
                this.setState({
                    newUserModel: false,

                });
                this.clearForm();
            }
        });


    }
    updateUser(flag, e) {


        if(this.state.userType=='Internal') {
            if ((this.state.email).trim().indexOf("@innoviti.com", this.state.email.length - "@innoviti.com".length) !== -1) {
                //VALID
            } else {
                this.props.handleClick("tr", 3, "Please Enter Innoviti Email");
                return false;
            }
        }
         if(this.state.userSubGroupName==='Refund Module Admin' || this.state.userSubGroupName==='Refund Module Admin With Reports' || this.state.userSubGroupName==='Refund Module Operator' || this.state.userSubGroupName==='Refund Module Operator With Reports')
        {
            if(this.state.is_refund_enable===false){
                this.props.handleClick("tr", 3, "Refund Module is not Enabled for given Merchant");
                return false;
            }
        }
        if (this.validator.allValid()) {

            const data = new FormData();
            data.append('file', this.state.selectedFile);
            data.append('firstName', titleCase(this.state.firstName));
            data.append('lastName', titleCase(this.state.lastName));
            data.append('email', (this.state.email).trim());
            data.append('phone', this.state.phone);
            data.append('loginType', this.state.login_type);
            data.append('userType', this.state.userType);
            data.append('userGroup', this.state.userGroup);
            data.append('userSubGroup', this.state.userSubGroup);
            data.append('password', this.state.password);
            data.append('extra_data', this.state.extra_data);
            data.append('pass_exp', true);
            data.append('contact_title', this.state.contact_title);
            data.append('api_key', 'gTrk2cJYgLtzDp2PBJ05b6Bczm3jbuR82VzvzOBehys=');
            data.append('user_admin_access', this.state.user_admin_access);
            data.append('user_approval_access', this.state.user_approval_access);
            data.append('objectType', this.state.object_type);
            data.append('objectCode', this.state.object_code);
            data.append('designation', this.state.designation);
            data.append('created_by', this.state.created_by);
            data.append('updated_by', this.state.updated_by);
            data.append('organizationName', this.state.organizationName);
            data.append('authType', this.state.auth_type);
            data.append('account_expiry_date', this.state.account_expiry_date);
            data.append('edit_user_id', this.state.edit_user_id);
            data.append('send_mail', this.state.send_mail);
            data.append('document', this.state.edit_file);
            data.append('is_active', this.state.is_active);
            data.append('edited_by', this.state.edited_by);
            data.append('edit_request_by', this.state.edit_request_by);
            data.append('delete_request_by', this.state.delete_request_by);
            data.append('userSubGroupName', this.state.userSubGroupName);
            data.append('userSubGroupName', this.state.userSubGroupName);
            data.append('tablueUserName', this.state.tablueUserName);
            data.append('user_department', this.state.user_department);
            let uri = '/users/edituser/'

            if(this.state.edit_req===true && flag==''){
                uri = '/users/edit_req/'
                data.append('password_edited', this.state.password_edited);
            }
            if(this.state.delete_req===true && flag==''){
                uri = '/users/delete_req/'
            }
            if(this.state.delete_req===true && flag=='3'){
                uri = '/users/delete_reject_req/'
            }
            if(flag=='1'){
                uri = '/users/re_send_activation_mail/'
            }
            if(this.state.edit_req===true && flag=='2'){
                uri = '/users/reject_req/'
            }

            axios.post(config.get('API_URL') + uri, data, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {

                //console.log("gditttttttt", response);
                if (response.data.error) {
                    this.props.handleClick("tr", 3, response.data.error);
                } else {
                    this._refreshUsers();
                    if(this.state.edit_req===true && flag==''){
                        this.props.handleClick("tr", 1, "Record has been successfully updated.");

                    } else if(this.state.edit_req===true && flag=='2'){
                        this.props.handleClick("tr", 1, "Edit request has been rejected.");

                    } else if(flag==1){
                        this.props.handleClick("tr", 1, "Activation mail has been sent successfully.");
                    }
                    else if(this.state.delete_req===true && flag==''){
                        this.props.handleClick("tr", 1, "User has been successfully Deleted.");
                    }
                    else if(this.state.delete_req===true && flag=='3'){
                        this.props.handleClick("tr", 1, "Delete request has been rejected.");
                    }
                    else if(this.state.is_active=='pending_approval'){
                        this.props.handleClick("tr", 1, "Record has been successfully updated.");
                    }
                    else{
                        this.props.handleClick("tr", 1, "Edit request has been send successfully for approval.");
                    }

                    this.setState({
                        newUserModel: false,

                    });
                    this.clearForm();
                }
            });
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
        }

    }

    editUser(action_type, id, firstName, lastName, email, phone, userType, userGroup, loginType, userSubGroup,  groupNAme, extraData, is_active, contact_title, user_admin_access, user_approval_access,onboarding_document, designation, objectType, objectCode, password, authType, account_expiry_date,last_logged_on, userSubGroupName, tablueUserName, user_department) {
        //alert(userSubGroupName);

        if(typeof user_admin_access==='string'){
            user_admin_access = (user_admin_access === "true");
        }
        if(typeof user_approval_access==='string'){
            user_approval_access = (user_approval_access === "true");
        }

        objectCode = objectCode.split(",");
        if(action_type=='User Profile'){
            this.setState({
                newInfoModel: !this.state.newInfoModel
            })

        }
        else {
            this.setState({
                newUserModel: !this.state.newUserModel,

            })
        }

        var orgz = '';
        if(extraData!=null && extraData!='null')
        {
            if(extraData.hasOwnProperty("organization")===true) {
                orgz = extraData.organization;
                orgz = orgz.split(",");
            }
        }
        if(this.state.logged_user_type=='Internal') {

            this.findGroups(userType,'',userSubGroupName);


        }
        this.findSubGroups(userGroup,'');
        //if(this.state.logged_user_type=='Internal') {
        if(userSubGroupName==='GENIE Sales Team') {
            this.findOrgName(objectCode, objectType, 'External')
        } else {
            this.findOrgName(objectCode, objectType, userType)
        }

        //}

        this.setState({
            send_mail: false,

            edit_user_id: id,
            user_admin_access: user_admin_access,
            user_approval_access: user_approval_access,
            firstName: firstName,
            lastName: lastName,
            email: email,
            phone: phone,
            password_edited: password,
            // confirm_password: password,
            userType: userType,
            is_active: is_active,
            contact_title: contact_title,
            userGroup: userGroup,
            userSubGroup: userSubGroup,
            object_type: objectType,
            object_code: objectCode,
            designation: designation,
            extra_data:null,
            selectedFile: onboarding_document,
            edit_file: onboarding_document,
            organizationName: orgz,
            action_type:action_type,
            auth_type: authType,
            login_type: loginType,
            account_expiry_date: account_expiry_date,
            last_logged_on:last_logged_on,
            userSubGroupName:userSubGroupName,
            tablueUserName:tablueUserName,
            user_department: user_department
        });
        if(userSubGroupName==='Refund Module Admin' || userSubGroupName==='Refund Module Admin With Reports' || this.state.userSubGroupName==='Refund Module Operator' || this.state.userSubGroupName==='Refund Module Operator With Reports')
        {
            setTimeout(function(){
                this.checkRefundModuleStatus()
            }.bind(this), 200);
        }
    }

    findOrgName(code, tblName, userType) {
        var orgt = []
        if(userType=='Internal') {
            return false;
        }
        //alert(code);
        if(tblName == 'Acquiring Bank') {

            axios.post(config.get('API_URL')+'/users/acq-banks-name/', {
                code: code

            }, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                // var newStr = '';
                // if (response.data.acq_bank_name != '')  {
                //      newStr = response.data.acq_bank_name.replace(/  +/g, ' '); //console.log(value[name]);
                // }
                // var clean_text = newStr.trim()

                if (Object.keys(response.data.data).length != 0) {
                    Object.keys(response.data.data).map(function (key, i) {
                        var short_code = response.data.data[key].sort(function(a, b){return a - b});
                        orgt.push({value: short_code.join(), label: key})
                    });
                }

                this.setState({
                    organization: orgt
                })
            });

        }
        else {
            axios.post(config.get('API_URL') + '/users/get_org_name/', {
                table_name: tblName,
                code: code
            }, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                response.data.map((value, index) => {
                    orgt.push({value: value.code, label: value.name})
                })
                this.setState({
                    organization: orgt,
                    orgObject: orgt
                })
                setTimeout(function() {
                    this.findOrganization(tblName, userType, false, '', 'edit');

                }.bind(this), 200);

            })
                .catch((error) => {
                    this.state.organization = '';
                    this.state.organizationList.length = 0;
                });
        }
    }

    _refreshUsers() {

        const that = this;
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        if ($.fn.DataTable.isDataTable('#userTable')) {
            $('#userTable').DataTable().destroy();

        }
        var filters = {
            filter_userType: this.state.filter_userType,
            userFilterGroup: this.state.userFilterGroup,
            orgnization_codes: this.state.orgnization_codes,
            user_status: this.state.user_status
        }
        var data = {
            obj_type: decoded.object_type,
            obj_code: this.state.external_users,
            user_type: decoded.userType,
            logged_uid: decoded._id,
            filters: filters
        }
        var usrList = $('#userTable').DataTable(
            {
                order: [],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo": true,
                "autoWidth": false,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 - 1], [20, 50, 100, 500, "All"]],

                ajax: {
                    url: config.get('API_URL') + "/users/allusers",
                    type: "POST",
                    data: data,
                    dataSrc: function (json) { //console.log(json.data);
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function (request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },

                columns: [
                    {"data": "name"},
                    {"data": "email"},
                    {"data": "user_type"},
                    {"data": "group_name"},
                    {"data": "subgroup_name"},
                    {"data": "org"},
                    {"data": "status"},
                    {"data": "comments"},
                    {"data": "user_id"},
                    {"data": "is_approve"},
                ],
                "columnDefs": [
                    {

                        "className":"text-center",
                        "targets": 5,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {
                            $(td).text('');

                            if(rowData.org==null || rowData.org=='null' || rowData.org=='') {
                                $(td).text('');

                            }
                            else {
                                var n = rowData.org.split(",").length;
                                if (n > 1) {
                                    var trimmedString = rowData.org.split(",")[0];
                                    $(td).append(trimmedString + ' <a href="#"  data-tip="Stop" title="View" id="View"  class="" >View All..</a>');
                                    $(td).click(e => {
                                        this.toggleNewOrgModel(e, rowData.org);
                                    })
                                } else {
                                    $(td).append(rowData.org );

                                }
                            }
                        },
                        bSortable: false,
                    },
                    {
                        "width": "15%",
                        render: function (data, type, row) {
                            // console.log(data); console.log(row);
                            var strArray = data.split("_");
                            var id = strArray[0];
                            var status = strArray[1];
                            var active = '';
                            var unlock_icon = '';
                            if (status == 'active') {
                                active = 'checked';
                            }
//                             if(row.event=='account_locked' || row.login_attempts>4){
//                                 unlock_icon = '<a href="#" data-tip="Unlock" data-id="' + id + '" class="btn btn-default actionBtn btn-delet" role="button" >' +
//                                     '<i class="fa fa-unlock" aria-hidden="true"></i>' +
//                                     '</a>';
//                             }
                            return '<td ><a href="#" data-tip="Edit" data-id="' + id + '" class="btn btn-default actionBtn btn-edit" role="button">' +
                                '<span class="glyphicon glyphicon-edit" aria-hidden="true"></span></a>&nbsp;     ' +
                                '<a href="#" data-tip="Delete" data-id="' + id + '" class="btn btn-default actionBtn btn-delet" role="button" >' +
                                '<span class="glyphicon glyphicon-remove" aria-hidden="true"></span>' +
                                '</a>' +
                                // '<a href="#" data-tip="Info" data-id="' + id + '" class="btn btn-default actionBtn btn-info" role="button" >' +
                                // '<span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span>' +
                                // '</a> &nbsp;'+
                                '<label class="switch">' +
                                '<input type="checkbox" data-id="' + id + '" data-status="' + status + '" data-group="' + row.group_name +'" class="user_status" ' + active + '>' +
                                '<span class="slider round"></span>' +
                                '</label> &nbsp;' + unlock_icon


                                +
                                '</td>';
                        },
                        className: "action_button",
                        targets: 8,
                        aTargets: [-1]
                    },
                    {
                        "width": "5%",
                        render: function (data) {
                            var strArray = data.split("$$");
                            var id = strArray[0];
                            var status = strArray[1];
                            var edit_req = strArray[2];
                            var delete_req = strArray[5];
                            if ((status == 'pending_approval' && that.state.luser_type == 'Internal' && that.state.lsub_group == 'Admin') || (status == 'pending_approval' && that.state.is_user_approval_access === true)) {
                                return '<td ><a href="#" data-tip="Approve" title="Approve" data-id="' + id + '" class="btn btn-default actionBtn btn-edit" role="button">' +
                                    '<span class="glyphicon glyphicon-ok" aria-hidden="true"></span></a>&nbsp;     ' +

                                    '</td>';
                            }else if ((edit_req == 'true' && that.state.luser_type == 'Internal' && that.state.lsub_group == 'Admin')|| (edit_req == 'true' && that.state.is_user_approval_access === true)) {
                                return '<td ><a href="#" data-tip="Edit Request" title="Edit Request" data-id="' + id + '" class="btn btn-default actionBtn btn-edit" >' +
                                    '<span class="glyphicon glyphicon-ok" aria-hidden="true"></span></a>&nbsp;     ' +

                                    '</td>';
                            }else if ((delete_req == 'true' && that.state.luser_type == 'Internal' && that.state.lsub_group == 'Admin')|| (edit_req == 'true' && that.state.is_user_approval_access === true)) {
                                return '<td ><a href="#" data-tip="Delete Request" title="Delete Request" data-id="' + id + '" class="btn btn-default actionBtn btn-edit" >' +
                                    '<span class="glyphicon glyphicon-ok" aria-hidden="true"></span></a>&nbsp;     ' +

                                    '</td>';
                            } else {
                                return '<td ></td>';
                            }

                        },
                        className: "action_button",
                        targets: 9,
                        aTargets: [-1]
                    },


                ]
            });
        // axios.get(config.get('API_URL') + '/users/allusers/', {
        //     headers: {
        //         Authorization: ` ${localStorage.usertoken}`
        //     },
        //     params: {
        //         obj_type: decoded.object_type,
        //         obj_code: decoded.object_code,
        //         user_type: decoded.userType
        //     }
        // }).then(response => {  //console.log(response.data);
        //     this.setState({
        //         users: response.data
        //     });
        //     response.data.map((val, index)=>{
        //         var sta = true;
        //         if(val.status=='active') {
        //             sta = true;
        //         }
        //         else{
        //             sta = false;
        //         }
        //         this.setState({
        //             approve: {...this.state.approve, [index]:sta }
        //         })
        //     })
        //
        //     $('#userTable').DataTable(
        //         // {
        //         //     scrollX:        true,
        //         //     //scrollCollapse: true,
        //         //     // paging:         false,
        //         //     fixedColumns:   {
        //         //         leftColumns: 2,
        //         //         rightColumns: 1
        //         //     }
        //         // }
        //         );
        //     this.setState({
        //         loading: false
        //     })
        //
        // });
        //$(".user_status").change(function(e) {
        $('#userTable').on('click', 'td.action_button .user_status', function (e) {
            e.stopImmediatePropagation();
            var id = $(this).data("id");
            var status = $(this).data("status");
            var group = $(this).data("group");
            if (status == "pending") {
                alert("Please approve this user");
                return false;
            }
            that.changeStatus(this, id, group)
        })
        $('#userTable').on('click', 'td.action_button a', function (e) {
            e.stopImmediatePropagation();
            var id = $(this).data("id");
            var type = $(this).data("tip");
            if (type == 'Delete') {
                that.deleteUser(id);
            }
            if (type == 'Edit') {
                that.updUser(id, 'Edit User');
            }
            if (type == 'Info') {
                that.infoUser(id, 'User Profile');
            }
            if (type == 'Approve') {
                that.updUser(id, 'Activate User');

            }
            if (type == 'Edit Request') {
                that.updUser(id, 'Edit Request');

            }
            if (type == 'Delete Request') {
                that.updUser(id, 'Delete Request');

            }
            if(type == 'Unlock') {
                that.unlockUser(id)
            }
        })
    }

    updUser(id, act) {
        if(act==='Activate User' || act==='Edit Request' || act==='Delete Request'){
            this.setState({
                disableInput: true,
                orgListOpen: false,
            })
        } else {
            this.setState({
                disableInput: false
            })
        }

        var data1 = {
            uid: id
        }
        axios.post(config.get('API_URL') + '/users/user_info/', data1, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {

            if(act==='Edit Request') {
                this.setState({
                    edit_req:true,
                    delete_req:false,
                    edited_by:response.data.edit_additional_info.updated_by,
                    edit_request_by:response.data.edit_request_by
                })
                let edit_tableau_username = ''
                if(response.data.edit_additional_info.tableau_username!==undefined)
                {
                    edit_tableau_username = response.data.edit_additional_info.tableau_username;
                }
                let edit_user_department = ''
                if(response.data.edit_additional_info.user_department!==undefined)
                {
                    edit_user_department = response.data.edit_additional_info.user_department;
                }

                this.editUser(act, response.data.user_id, response.data.edit_additional_info.first_name, response.data.edit_additional_info.last_name, response.data.edit_additional_info.email, response.data.edit_additional_info.phone, response.data.edit_additional_info.userType, response.data.edit_additional_info.group_id, response.data.edit_additional_info.login_type, response.data.edit_additional_info.subgroup_id, response.data.edit_additional_info.object_type, response.data.edit_additional_info.extra_data, response.data.edit_additional_info.status, response.data.edit_additional_info.contact_title, response.data.edit_additional_info.user_admin_access, response.data.edit_additional_info.user_approval_access,response.data.edit_additional_info.onboarding_document, response.data.edit_additional_info.designation, response.data.edit_additional_info.object_type, response.data.edit_additional_info.object_code, response.data.edit_additional_info.auth_data.password_encrypted, response.data.edit_additional_info.auth_type, response.data.edit_additional_info.account_expiry_date,response.data.authData.last_logged_on,response.data.edit_additional_info.subgroup_name,edit_tableau_username,edit_user_department)

            } else if(act==='Delete Request') {
                this.setState({
                    edit_req:false,
                    delete_req:true,
                    delete_request_by:response.data.delete_request_by
                })

                this.editUser(act, response.data.user_id, response.data.first_name, response.data.last_name, response.data.email, response.data.phone, response.data.groupsData.user_type, response.data.group_id, response.data.login_type, response.data.subgroup_id, response.data.groupsData.group_name, response.data.extra_data, response.data.status, response.data.contact_title, response.data.user_admin_access,response.data.user_approval_access, response.data.onboarding_document, response.data.designation, response.data.object_type, response.data.object_code, response.data.authData.password_encrypted, response.data.auth_type, response.data.account_expiry_date,response.data.authData.last_logged_on, response.data.subGroupsData.subgroup_name,response.data.tableau_username,response.data.user_department)
            }else {
                this.setState({
                    edit_req:false,
                    delete_req:false
                })
                this.editUser(act, response.data.user_id, response.data.first_name, response.data.last_name, response.data.email, response.data.phone, response.data.groupsData.user_type, response.data.group_id, response.data.login_type, response.data.subgroup_id, response.data.groupsData.group_name, response.data.extra_data, response.data.status, response.data.contact_title, response.data.user_admin_access,response.data.user_approval_access, response.data.onboarding_document, response.data.designation, response.data.object_type, response.data.object_code, response.data.authData.password_encrypted, response.data.auth_type, response.data.account_expiry_date,response.data.authData.last_logged_on, response.data.subGroupsData.subgroup_name,response.data.tableau_username,response.data.user_department)
            }

        });
    }
    infoUser(id, act) { //alert(act);
        var data1 = {
            uid: id
        }
        // this.setState({sending:!this.state.sending})
        axios.post(config.get('API_URL') + '/users/user_info/', data1, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            // console.log("uuuuuuuuuuuuu");
            // console.log(response.data.contact_title);
            // this.setState({sending:!this.state.sending})
            this.editUser(act, response.data.user_id, response.data.first_name, response.data.last_name, response.data.email, response.data.phone, response.data.groupsData.user_type, response.data.group_id, response.data.login_type, response.data.subgroup_id, response.data.groupsData.group_name, response.data.extra_data, response.data.status, response.data.contact_title, response.data.user_admin_access, response.data.user_approval_access, response.data.onboarding_document, response.data.designation, response.data.object_type, response.data.object_code, response.data.authData.password_encrypted, response.data.auth_type, response.data.account_expiry_date,response.data.authData.last_logged_on)

        });
    }

    deleteUser(id) {
        confirmAlert({
            title: 'Question',
            message: 'Are you sure you want to delete this user?.',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.handleClickDelete(id);
                }
            },
                {
                    label: 'No',
                }
            ]
        });
    }

    handleClickDelete(id) {
        var data = {
            uid: id,
            delete_request_by: this.state.updated_by
        }
        axios.post(config.get('API_URL') + '/users/deleteuser/', data,  {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            this._refreshUsers();
            this.props.handleClick("tr", 1, "Delete request has been send successfully for approval.");
        })
    }

    unlockUser(id) {
        confirmAlert({
            title: 'Question',
            message: 'Are you sure you want to unlock this user?.',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.handleClickUnlock(id);
                }
            },
                {
                    label: 'No',
                }
            ]
        });
    }
    handleClickUnlock(id) {
        var data = {
            uid: id
        }
        axios.post(config.get('API_URL') + '/users/unlock_user/', data,  {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            this._refreshUsers();
            this.props.handleClick("tr", 1, "User has been successfully unlocked.");
        })
    }
    findGroups(val, change_type, subgroupName) {

        disabledBody();
        axios.get(config.get('API_URL') + '/users/usergroups/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                userType: val,
                object_type: this.state.logged_object_type
            }
        }).then(response => {

            this.setState({
                userGroups: response.data,

            })
            if(this.state.action_type=='Add New User') {
                this.setState({

                    userSubGroups:[]
                })
            }
            if(change_type=='add'){
                this.changeUserGroups(response.data[0].group_id, response.data[0].group_name,'')
                this.setState({
                    userGroup: response.data[0].group_id
                })
            }
            if(response.data[0].user_type=="Internal" && subgroupName!=='GENIE Sales Team'){
                //this.findSubGroups(response.data[0].group_id,'default_load');
                this.setState({
                    userGroup: response.data[0].group_id,
                    group_select:false,
                    organization: {value: 'Innoviti', label: 'Innoviti'},
                    organizationList: [{value: 'Innoviti', label: 'Innoviti'}],
                    object_type: 'Innoviti',
                    object_code: 'Innoviti',
                    organizationName: 'Innoviti',
                })
            } else {
                if(this.state.action_type == 'Add New User') {
                    this.setState({
                        group_select:true,
                        organization:[],
                        //object_type: '',
                        object_code: ''
                    })
                }

            }
        });
        enabledBody();
    }

    findSubGroups(val, load_type) {
        disabledBody();
        axios.get(config.get('API_URL') + '/users/getsubgroup/', {

            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                groupId: val
            }
        }).then(response => {

            if (Array.isArray(response.data) && response.data.length) {
                this.setState({
                    userSubGroups: response.data
                })
            }
            if(load_type ==='default_load') {
                this.setState({
                    userSubGroup:response.data[0].subgroup_id,
                    userSubGroupName:response.data[0].subgroup_name
                })
            }
            enabledBody();
        });

        //get all merchant/ chain and other details

    }

    findOrganization(tblName, userType, is_search, search_value, action) {
        let selected_val = [];
        if(userType=='Internal') {
            return false;
        }
        if(is_search===true || action==='edit'){
            selected_val = this.state.orgObject
        }
        this.setState({
            objectType: tblName,
            organizationList:[],

        })

        if(tblName == 'Acquiring Bank') {
            this.setState({
               is_org_loading: true

            })
            axios.get(config.get('API_URL')+'/reports/acq-banks/', {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
            }).then(response => {
                var that = this;
                var orgnsLists = []
                if(response.data.data != null) {
                    Object.keys(response.data.data).map(function (key, i) {
                        var short_code = response.data.data[key].sort(function(a, b){return a - b});
                        orgnsLists.push({value: short_code.join(), label: key})
                    });
                    this.setState({
                        organizationList:orgnsLists,
                        is_org_loading: false
                    })
                }
            });

        }
        else {
            if(tblName==='Merchant' || tblName==='Chain' || tblName==='Store' || tblName==='Issuing Bank'){
                this.setState({
                    is_org_loading: true
                })
            }
            //console.log("val", selected_val);
            axios.post(config.get('API_URL') + '/users/getAllOrganization/', {

                table_name: tblName,
                object_code: this.state.object_code,
                object_type: this.state.logged_object_type,
                merchant_id: this.state.merchant_id,
                chain_id: this.state.chain_id,
                store_code: this.state.store_code,
                is_search: is_search,
                search_value: search_value,
                selected_value: selected_val
            }, {


                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                var orgnsList = []
                if (Array.isArray(response.data) && response.data.length) {
                    response.data.map((data, index) => {
                        orgnsList.push({value: data.code, label: data.name})
                    });
                    if (Array.isArray(this.state.object_code) && this.state.object_code) {
                        const uniq = new Set(orgnsList.map(e => JSON.stringify(e)));
                        orgnsList = Array.from(uniq).map(e => JSON.parse(e));
                    }
                } else {
                    this.state.organization = '';
                    this.state.organizationList.length = 0;
                }
                this.setState({
                    organizationList:orgnsList,
                    is_org_loading: false
                })

            })
                .catch((error) => {
                    this.state.organization = '';
                    this.state.organizationList.length = 0;
                });
        }
    }

    findFilterOrganization(tblName, userType) {
        if(userType=='Internal') {
            return false;
        }

        this.setState({
            isChange: true,
            organizationFilterList:[]
        })

        if(tblName == 'Acquiring Bank') {
            axios.get(config.get('API_URL')+'/reports/acq-banks/', {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
            }).then(response => {
                var that = this;
                if(response.data.data != null) {
                    Object.keys(response.data.data).map(function (key, i) {
                        var short_code = response.data.data[key].sort(function(a, b){return a - b});
                        that.state.organizationFilterList.push({value: short_code.join(), label: key})
                    });
                }
            });

        }
        else {
            axios.post(config.get('API_URL') + '/users/getFilterOrganization/', {
                table_name: tblName,
                object_code: this.state.object_code,
                object_type: this.state.logged_object_type,
                merchant_id: this.state.merchant_id,
                chain_id: this.state.chain_id,
                store_code: this.state.store_code
            }, {

                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
                if (Array.isArray(response.data) && response.data.length) {
                    response.data.map((data, index) => {
                        this.state.organizationFilterList.push({value: data.code, label: data.name})
                    });
                } else {
                    this.state.filterOrganization = '';
                    this.state.organizationFilterList.length = 0;
                }

            })
                .catch((error) => {
                    this.state.filterOrganization = '';
                    this.state.organizationFilterList.length = 0;
                });
        }
    }

    onLoginTypeChanged = e => {
        const {name, value} = e.target;
        this.setState({
            [name]: value
        });
    };
    onAuthTypeChanged = e => {
        const {name, value} = e.target;
        this.setState({
            [name]: value
        });
    };
    onPassChanged = e => {
        this.setState({[e.target.name]: e.target.value})
    };

    onFilterOrganizationchange(optionSelected) {
        let value = '';
        let orgArray = [];
        let orgName = [];
        if (optionSelected === null) {
            value = null;
        } else {
            optionSelected.map((orgs, i) => {
                orgArray.push(orgs.value)
                orgName.push(orgs.label)
                var index = this.state.organizationFilterList.findIndex(obj => obj.value == orgs.value);
                this.state.organizationFilterList.move(index, 0).join(',');
            });
        }

        this.setState({
            orgnization_codes: orgArray,
            filterOrganization: optionSelected,
            isChange: true
        });

    }
    onBankChange(optionSelected){
        let value = '';
        let orgArray = [];
        let orgName = [];
        if (optionSelected === null) {
            value = null;
        } else {
            optionSelected.map((orgs, i) => {
                orgArray.push(orgs.value)
                orgName.push(orgs.label)
                var index = this.state.organizationList.findIndex(obj => obj.value == orgs.value);
                this.state.organizationList.move(index, 0).join(',');
            });
        }

        this.setState({
            isChange: true,
            organization: optionSelected,
            object_code: orgArray,
            organizationName: orgName
        });

    }
    onOrganizationchange(store_object, checked_item, e) {
        //console.log(store_object)
        let item_list = this.state.object_code;
        let item_list_object = this.state.orgObject;
        let checked_list = store_object.value;
        let checked_list_object = store_object;
        let item_list1 = this.state.organizationName;
        let checked_list1 = store_object.label;
        //console.log(checked_list);
        if(checked_item===false) {
            const newData = [store_object, ...this.state.organizationList.filter(item => item !== store_object)];
            this.setState({
                object_code: [...this.state.object_code,  store_object.value],
                organizationName: [...this.state.organizationName,  store_object.label],
                orgObject: [...this.state.orgObject, store_object],
                isChange: true,
                organizationList: newData,

            });

        } else{
            let index = item_list.indexOf(checked_list);
            if (index > -1) {
                item_list.splice(index, 1);
                if(item_list.length<1) {
                    item_list='';
                }
                this.setState({
                    object_code: item_list,
                })
            }
            let index1 = item_list1.indexOf(checked_list1);
            if (index1 > -1) {
                item_list1.splice(index1, 1);
                if(item_list1.length<1) {
                    item_list1='';
                }
                this.setState({
                    organizationName: item_list1,
                })
            }
            let index_object = item_list_object.indexOf(checked_list_object);
            if (index_object > -1) {
                item_list_object.splice(index_object, 1);
                if(item_list_object.length<1) {
                    item_list_object=[];
                }
                this.setState({
                    orgObject: item_list_object,
                    isChange: true
                })
            }
        }
        if(this.state.userSubGroupName==='Refund Module Admin' || this.state.userSubGroupName==='Refund Module Admin With Reports' || this.state.userSubGroupName==='Refund Module Operator' || this.state.userSubGroupName==='Refund Module Operator With Reports')
        {
            setTimeout(function(){
                 this.checkRefundModuleStatus()
            }.bind(this), 200);
        }

        if (e.target.type === 'checkbox') {
            e.stopPropagation();
        }
    }

    // onOrganizationchange(optionSelected) {
    //     this.setState({
    //         organization: optionSelected,
    //         object_code: optionSelected.value,
    //         organizationName: optionSelected.label
    //     })
    //
    // }
    changeStatus(obj, id, group) {
        //alert(obj.checked);

        let status = '';
        if (obj.checked === true) {
            status = "Activate"
        } else {
            status = "Deactivate"
        }
        // this.setState({
        //     approve: {...this.state.approve, [index]:checked }
        // })
        confirmAlert({
            title: 'Question',
            message: 'Are you sure you want to '+status+' this user?.',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.handleChangeStatus(obj, id, group);
                }
            },
                {
                    label: 'No',
                    onClick: () => {
                        this.handleChangeStatusNo(obj, id);
                    }
                }

            ]
        });
    }

    handleChangeStatusNo(obj, id) {
        //alert(obj.checked)
        if (obj.checked === true) {
            $(obj).prop("checked", false);
        } else {
            $(obj).prop("checked", true);
        }


    }

    handleChangeStatus(obj, id, group) {
        var checked = obj.checked

        axios.get(config.get('API_URL') + '/users/change_status/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: id,
                checked: checked,
                email: this.state.updated_by
            }
        }).then(response => {
            this.props.handleClick("tr", 1, "User has been successfully updated.");
            if(group==='SRO' && checked==false) {
                this.deactivate_sro(id);
            }
            this._refreshUsers();
        });
    }
    deactivate_sro(id) {
        axios.get(config.get('API_URL') + '/inventory/deactivate_sro/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`,
                SalesforceToken: ` ${localStorage.salesforce_token}`
            },
            params: {
                id: id,

            }
        }).then(response => {

        });
    }
    downloadDocFile(){
        var postData = {
            fileName: this.state.edit_file
        }
        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/users/file-download/",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = this.state.edit_file;
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                window.URL.revokeObjectURL(url);

            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })
    }
    handleCheck(e){
        this.setState({
            [e.target.name]:e.target.checked
        })

    }
    toggleNewOrgModel(e, issue) {
        this.setState({
            newOrgModel: !this.state.newOrgModel,
            all_orgs: issue
        })
    }
    reset_all() {
        this.setState({
            filter_userType:'',
            userFilterGroup:'',
            orgnization_codes:'',
            filterOrganization:[]
        })
        setTimeout(function(){
            this.componentDidMount()
        }.bind(this), 200);

    }
    downLoadUserReport (e){

        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: ''
        });
        var postData = {
            filter_userType: this.state.filter_userType,
            userFilterGroup: this.state.userFilterGroup,
            orgnization_codes: this.state.orgnization_codes
        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/user-reports-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+'users_report.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
//                 let a = document.createElement('a');
                   let url = window.URL.createObjectURL(blob);
//                 a.href = url;
//                 a.download = rfile;
//                 a.click();
//                 window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    orgToggleList(is_disabled) {
        if(is_disabled===false){
            this.setState({
                orgListOpen: !this.state.orgListOpen,
            });
        }

    }
    orgFilterList(e){
        var value = e.target.value
        if(value.length>2 || value.length===0){
            setTimeout(function() {
            if(this.state.userSubGroupName==='GENIE Sales Team')
            {
                this.findOrganization(this.state.object_type, 'External',true, value, '');
            }else{
                this.findOrganization(this.state.object_type, this.state.userType,true, value, '');
            }
           }.bind(this), 200);
        }

    }
    closeOrgList() {
        this.setState({
            orgListOpen: false,
        });
    }
    changeDepartment(e){
        this.setState({
            user_department:e.target.value
        })
    }
    checkRefundModuleStatus() {
        if(this.state.object_code.length>0){

        var data = {
            user_type: this.state.object_type,
            object_code: this.state.object_code
        }
        axios.post(config.get('API_URL') + '/RefundModule/is_refund_module_enable/', data,  {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            var enb = false;
//             var hu = [
//         {
//             "merchant_code": "SA270249",
//             "refund_status": "DISABLE"
//         },
//         {
//             "merchant_code": "SA270249",
//             "refund_status": "DISABLE"
//         }
//     ];
            response.data.data.map((res, i) => {
               if(res.refund_status==='ENABLE') {
                  enb = true;
               }
            });
            this.setState({
                is_refund_enable_lists:response.data.data,
                is_refund_enable:enb
            })
        })
       } else {
            this.setState({
                is_refund_enable_lists:[],
                is_refund_enable:false
            })
       }
    }
    render() {
         console.log("code",this.state.object_code);
        // console.log("object",this.state.orgObject);
        // console.log(this.state.object_code.length);
        // console.log("ex",this.state.organizationName);
        // console.log("exobj",this.state.object_type);
        // console.log("kkk", this.state.userType);
//          console.log(this.state.organization);
//          console.log(this.state.organizationList);
        var orgClass = "dd-header";
        if(this.state.disableInput===true){
            orgClass = "dd-header-disabled";
        }
        var vcls = "btn btn-sm btn-default switchMetric";
        var ccls = "btn btn-sm btn-default switchMetric";
        if(this.state.user_admin_access=== true ) {
            vcls = "btn btn-sm btn-primary switchMetric";
            ccls = "btn btn-sm btn-default switchMetric";
        }
        if(this.state.user_admin_access=== false ) {
            vcls = "btn btn-sm btn-default switchMetric";
            ccls = "btn btn-sm btn-primary switchMetric";
        }

        var vclsa = "btn btn-sm btn-default switchMetric";
        var cclsa = "btn btn-sm btn-default switchMetric";
        if(this.state.user_approval_access=== true ) {
            vclsa = "btn btn-sm btn-primary switchMetric";
            cclsa = "btn btn-sm btn-default switchMetric";
        }
        if(this.state.user_approval_access=== false ) {
            vclsa = "btn btn-sm btn-default switchMetric";
            cclsa = "btn btn-sm btn-primary switchMetric";
        }

        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }

        const customStyles = {
            control: provided => ({
                ...provided,
                padding: "0px",
                minHeight: "38px",


            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "38px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
        };


        let tableauUsers = this.state.tableau_username.map((tableau_user, index) => {
            return (
                <option value={tableau_user} key={index + 1}>{tableau_user}</option>
            )
        });
        let departments = this.state.departmentLists.map((department, index) => {
            return (
                <option value={department.department_id} key={index + 1}>{department.department_name}</option>
            )
        });

        let allgroups = this.state.userGroups.map((group, index) => {
            return (
                <option value={group.group_id} key={index + 1}>{group.group_name}</option>
            )
        });

        let allSubgroups = this.state.userSubGroups.map((subgroup, index) => {
            return (
                <option value={subgroup.subgroup_id} key={index + 1}>{subgroup.subgroup_name}</option>
            )
        });
        var ut = 'merchant_code';
        if(this.state.object_type==='Chain')    {
            ut = 'chain_code';
        }
        if(this.state.object_type==='Store')    {
            ut = 'store_code';
        }
        let re_status = this.state.is_refund_enable_lists.map((refund_enable, index) => {
            let statusColor = refund_enable.refund_status === 'ENABLE' ? "#008000" : "#F00";
            return (
                <span className="res_text">{refund_enable[ut]}: <span style={{color: statusColor}}>{refund_enable.refund_status}</span>,&nbsp;</span>
            );
        });

        this.validator.purgeFields();
        let confirmPasswordError = '';
        let passwordError = '';
        if(config.get('API_URL')!='https://sparcs.innoviti.com/api/node') {
            if (this.state.action_type == 'Add New User' || this.state.password != '') {
                confirmPasswordError = this.validator.message('confirm_password', this.state.confirm_password, `required|in:${this.state.password}`, {messages: {in: 'Passwords need to match!'}});
                passwordError = this.validator.message('password', this.state.password, 'required|min:6|max:20');
            } else {
                confirmPasswordError = '';
                passwordError = '';
            }
        }

        let users = this.state.users.map((user, index) => {
            var org = '';
            if(user.extra_data!=null && user.extra_data!='null')
            {
                if(user.extra_data.hasOwnProperty("organization")===true) {
                    org = user.extra_data.organization
                }
            }
            var comments = '';
            var actWidth = '200px';
            if(user.groupsData.user_type=='External') {
                actWidth = '80px';
            }
            if(user.status=='pending_approval') {
                comments = 'Pending Approval';
            } else if(user.authData.event=='account_locked') {
                comments = 'Account Locked';
            }

            return (
                <tr key={index + 1}>
                    {/*<td width="30px">{index + 1}</td>*/}
                    <td>{user.first_name} {user.last_name}</td>
                    <td>{user.email}</td>
                    <td>{user.groupsData.user_type}</td>
                    <td>{user.groupsData.group_name}</td>
                    <td>{user.subGroupsData.subgroup_name} </td>
                    <td>{org} </td>
                    <td>{capitalizeFirstLetter(user.status)} </td>
                    <td>{comments} </td>
                    <td width={actWidth}>
                        <span className="hidden"> {user.status}</span>
                        <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                        <a href="#" data-tip="Edit" className="btn btn-default actionBtn btn-edit" role="button"
                           onClick={this.editUser.bind(this, 'Edit User', user.user_id, user.first_name, user.last_name, user.email, user.phone, user.groupsData.user_type, user.group_id, user.login_type, user.subgroup_id, user.groupsData.group_name, user.extra_data, user.status, user.contact_title, user.user_admin_access,user.user_approval_access, user.onboarding_document, user.designation, user.object_type, user.object_code, user.authData.password_encrypted, user.auth_type, user.account_expiry_date)}><span
                            className="glyphicon glyphicon-edit" aria-hidden="true"></span></a>
                        &nbsp;
                        <a href="#" data-tip="Delete" className="btn btn-default actionBtn btn-delet" role="button"
                           onClick={this.deleteUser.bind(this, user.user_id, user.name, user.email)}> <span
                            className="glyphicon glyphicon-remove" aria-hidden="true"></span></a>
                        &nbsp;
                        <a href="#" data-tip="Info" className="btn btn-default actionBtn btn-info" role="button"
                           onClick={this.infoUser.bind(this, 'Info User', user.user_id, user.first_name, user.last_name, user.email, user.phone, user.groupsData.user_type, user.group_id, user.login_type, user.subgroup_id, user.groupsData.group_name, user.extra_data, user.status, user.contact_title, user.user_admin_access, user.user_approval_access,user.onboarding_document, user.designation, user.object_type, user.object_code, user.authData.password_encrypted, user.auth_type, user.account_expiry_date)}> <span
                            className="glyphicon glyphicon-info-sign" aria-hidden="true"></span></a>
                        &nbsp;
                        {this.state.luser_type=='Internal' && this.state.lsub_group=='Admin'?
                            <Switch className="react-switch" height={18} width={38} onChange={this.changeStatus.bind(this,index,user.user_id)} checked={(this.state.approve[index])? true : false} />
                            :null}
                    </td>
                    <td>
                        {user.status=='pending_approval' && this.state.luser_type=='Internal' && this.state.lsub_group=='Admin'?
                            <a href="#" data-tip="Approve" className="btn btn-default actionBtn btn-edit" role="button"
                               onClick={this.editUser.bind(this, 'Activate User', user.user_id, user.first_name, user.last_name, user.email, user.phone, user.groupsData.user_type, user.group_id, user.login_type, user.subgroup_id, user.groupsData.group_name, user.extra_data, user.status, user.contact_title, user.user_admin_access,user.user_approval_access, user.onboarding_document, user.designation, user.object_type, user.object_code,  user.authData.password_encrypted, user.auth_type, user.account_expiry_date)}><span
                                className="glyphicon glyphicon-ok" aria-hidden="true"></span></a>
                            : null }
                    </td>
                </tr>
            )
        });
        const orgn_lists = this.state.organizationList.map((store_object, index) => {
             //console.log("store_object", store_object);
            // console.log(store_object);
            var chks_input = <input type='checkbox' checked={false}/>
            var activeCls_s = 'dd-list-item';
            var checked_items = false;
            if(this.state.object_code.includes(store_object.value) === true){
                chks_input = <input type='checkbox' checked={true}/>
                activeCls_s = "dd-list-item dd-list-active";
                checked_items = true;
            }
            return (
                <li key={index} className={activeCls_s} onClick={this.onOrganizationchange.bind(this, store_object,checked_items)}>
                    {chks_input}
                    &nbsp;&nbsp;{store_object.label}
                </li>
            )
        })
        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 userModelBox pt-5">
                            <ModalD visible={this.state.user_upload} width="400" height="330" effect="fadeInUp">
                                <div className="">
                                    <div className="col-md-1 pull-right">
                                        <a href="javascript:void(0);" onClick={() => this.closeUploadModal()}>
                                            <i className="fa fa-times-circle" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="">
                                        <div className="col-sm-7 col-sm-offset-3">
                                        <a href={usersSample} download className="grey-border-button" style={{fontSize:12}}>Download sample template</a>
                                        </div>
                                        <div className="clearfix"></div><br/><br/>
                                        <div className="col-sm-7 col-sm-offset-3">
                                        <div className="form-group">
                                                <label htmlFor="queryName" className="">Upload Your Excel File</label>
                                                <input type="file" name="file" className="form-control-file" onChange={this.onPreviewDropUsers} />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="queryName" className="">Upload Onboarding Document</label>
                                                <input type="file" name="fileDoc" className="form-control-file" onChange={this.onPreviewDropUsersDoc} />
                                            </div>
                                        </div>




                                        <div className="col-sm-6 col-sm-offset-4">
                                            <button type="button" className="btn btn-primary" role="button"  onClick={this.importUsers.bind(this)}>Submit</button>
                                        </div>

                                        <div className="clearfix"></div>
                                        <div className='sweet-loading'>
                                        <BeatLoader
                                            css={override}
                                            sizeUnit={"px"}
                                            size={10}
                                            color={'#123abc'}
                                            loading={this.state.upload_loading}
                                        />
                                        </div>


                                    </div>
                                </div>
                            </ModalD>

                            <Modal isOpen={this.state.newInfoModel} toggle={this.toggleInfoUserModel.bind(this)}>
                                <ModalHeader toggle={this.toggleInfoUserModel.bind(this)}>{this.state.action_type}</ModalHeader>
                                <ModalBody>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-sx-12">
                                            <div className="content">
                                                {/* <div className="card"> */}
                                                {/* {this.state.loader === false ? */}
                                                <div className="row">

                                                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                                                        <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12  p-5"
                                                             style={{
                                                                 textAlign: "-webkit-center",
                                                                 background: 'linear-gradient(134.72deg, #F5B00A 0%, #FE6009 100%)',
                                                                 marginBottom: '10px',
                                                             }}
                                                        >
                                                            <img
                                                                src={imgNobody }
                                                                className="profile text-center"
                                                                style={{ height: "100px", borderRadius: "50%" }}
                                                            />

                                                            <div className="col-md-12 col-xs-12 col-sm-12 col-lg-12 p-5 text-center">
                                                                <p style={{ color: "#fff", fontSize: "120%" }}>
                                                                    {this.state.firstName + " "+ this.state.lastName}

                                                                </p>
                                                                <p style={{ color: "#fff" }}> {this.state.organizationName} </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 ">

                                                            <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">
                                                                <div className="col-lg-3 col-md-3 col-xs-3 col-sm-3 p-0">
                                                                    <p className="profile-head">Email</p>
                                                                </div>
                                                                <div className="col-lg-1 col-md-1 col-xs-1 col-sm-1 p-0">
                                                                    <p className="profile-head">:</p>
                                                                </div>
                                                                <div className="col-lg-8 col-md-8 col-xs-8 col-sm-8 p-0">
                                                                    <p>
                                                                        {this.state.email}

                                                                    </p>
                                                                </div>
                                                            </div>
                                                            {/* <div className="col-lg-12 col-md-6 col-sm-12 col-xs-12 devider"></div> */}
                                                            <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">
                                                                <div className=" col-lg-3 col-md-3 col-xs-2 col-sm-3  p-0">
                                                                    <p className="profile-head">Mobile</p>
                                                                </div>
                                                                <div className="col-lg-1 col-md-1 col-xs-1 col-sm-1 p-0">
                                                                    <p className="profile-head">:</p>
                                                                </div>
                                                                <div className=" col-lg-8 col-md-8 col-xs-8 col-sm-8  p-0">
                                                                    <p style={{float:'left'}}>
                                                                        +91 {this.state.phone}
                                                                    </p>{" "}
                                                                    <span
                                                                        style={{ color: "#14ce14", padding: "0px 10%" }}
                                                                    >
                                                    verified
                                                </span>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">
                                                                <div className="col-md-3 col-xs-3 col-sm-3 col-lg-3 p-0">
                                                                    <p className="profile-head">Designation</p>
                                                                </div>
                                                                <div className="col-lg-1 col-md-1 col-xs-1 col-sm-1 p-0">
                                                                    <p className="profile-head">:</p>
                                                                </div>
                                                                <>
                                                                    {this.state.designation==""?
                                                                        <div className="col-md-8 col-xs-8 col-sm-8 col-lg-8 p-0">
                                                                            { this.state.desigEditBox &&  <input id="designation" name="designation" value={this.state.designation} />}
                                                                            { !this.state.desigEditBox && <span class="glyphicon glyphicon-pencil" style={{marginLeft:'10px'}} aria-hidden="true" onClick={() =>{this.setState({desigEditBox:true})}}/> }
                                                                            {this.state.desigEditBox && <>
                                                                                <span class="glyphicon glyphicon-remove-sign" style={{marginLeft:'10px',color:'red',cursor:'pointer'}} aria-hidden="true" onClick={() =>{this.setState({desigEditBox:!this.state.desigEditBox})}}/>
                                                                                <span class="glyphicon glyphicon-ok-sign" style={{marginLeft:'10px',color:'green',cursor:'pointer'}} aria-hidden="true" onClick={() =>{this.setState({desigEditBox:!this.state.desigEditBox})}}/>
                                                                            </>
                                                                            }
                                                                        </div>
                                                                        :
                                                                        <div className="col-md-8 col-xs-8 col-sm-8 col-lg-8 p-0">
                                                                            <p
                                                                                style={{
                                                                                    float: "left",
                                                                                    textTransform: "capitalize",
                                                                                    wordBreak: 'break-word',
                                                                                }}
                                                                            >
                                                                                {this.state.designation}
                                                                            </p>
                                                                        </div>
                                                                    }
                                                                </>
                                                            </div>
                                                            <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">
                                                                <div className="col-md-3 col-xs-5 col-sm-5 col-lg-3 p-0">
                                                                    <p className="profile-head">Auth Type</p>
                                                                </div>
                                                                <div className="col-lg-1 col-md-1 col-xs-1 col-sm-1 p-0">
                                                                    <p className="profile-head">:</p>
                                                                </div>
                                                                <>
                                                                    { this.state.auth_type==""?
                                                                        <div className="col-md-8 col-xs-8 col-sm-8 col-lg-8 p-0">
                                                                            { this.state.authEditBox && <input id="auth type" name="auth type" value={this.state.auth_type} />}
                                                                            { !this.state.authEditBox && <span class="glyphicon glyphicon-pencil" style={{marginLeft:'10px'}} aria-hidden="true" onClick={() =>{this.setState({authEditBox:true})}}/> }
                                                                            {this.state.authEditBox && <>
                                                                                <span class="glyphicon glyphicon-remove-sign" style={{marginLeft:'10px',color:'red',cursor:'pointer'}} aria-hidden="true" onClick={() =>{this.setState({authEditBox:!this.state.authEditBox})}}/>
                                                                                <span class="glyphicon glyphicon-ok-sign" style={{marginLeft:'10px',color:'green',cursor:'pointer'}} aria-hidden="true" onClick={() =>{this.setState({authEditBox:!this.state.authEditBox})}}/>
                                                                            </>
                                                                            }
                                                                        </div>
                                                                        :
                                                                        <div className="col-md-8 col-xs-8 col-sm-8 col-lg-8 p-0">
                                                                            <p
                                                                                style={{
                                                                                    float: "left",
                                                                                    textTransform: "capitalize",
                                                                                    wordBreak: 'break-word',
                                                                                }}
                                                                            >
                                                                                {this.state.auth_type}
                                                                            </p>
                                                                        </div>
                                                                    }
                                                                </>


                                                            </div>

                                                            <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">
                                                                <div className="col-md-3 col-xs-5 col-sm-5 col-lg-3 p-0">
                                                                    <p className="profile-head">Last Access</p>
                                                                </div>
                                                                <div className="col-lg-1 col-md-1 col-xs-1 col-sm-1 p-0">
                                                                    <p className="profile-head">:</p>
                                                                </div>
                                                                <div className="col-md-8 col-xs-8 col-sm-8 col-lg-8 p-0">
                                                                    <p
                                                                        style={{
                                                                            float: "left",
                                                                            textTransform: "capitalize",
                                                                            wordBreak: 'break-word',
                                                                        }}
                                                                    >
                                                                        {moment(new Date(this.state.last_logged_on)).format("DD-MM-YYYY HH:mm:ss")}
                                                                    </p>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 p-0">
                                                                <div className="col-md-3 col-xs-5 col-sm-5 col-lg-3 p-0">
                                                                    <p className="profile-head">Status</p>
                                                                </div>
                                                                <div className="col-lg-1 col-md-1 col-xs-1 col-sm-1 p-0">
                                                                    <p className="profile-head">:</p>
                                                                </div>
                                                                <div className="col-md-8 col-xs-8 col-sm-8 col-lg-8 p-0">
                                                                    <p
                                                                        style={{
                                                                            float: "left",
                                                                            textTransform: "capitalize",
                                                                            color: this.state.is_active==="active"?"#14ce14":"red",
                                                                            wordBreak: 'break-word',
                                                                        }}
                                                                    >
                                                                        {this.state.is_active}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* :
                                        <BeatLoader
                                            css={override}
                                            sizeUnit={"px"}
                                            size={15}
                                            color={'#123abc'}
                                            loading={this.state.loader}
                                        />
                                        } */}
                                                {/* </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </ModalBody>
                            </Modal>
                            <Modal isOpen={this.state.newUserModel} toggle={this.toggleNewUserModel.bind(this)}>
                                <ModalHeader toggle={this.toggleNewUserModel.bind(this)}>{this.state.action_type}</ModalHeader>
                                <ModalBody className="user_form_fields">
                                    <div className="row">
                                        {this.state.logged_user_type == 'Internal'?
                                            <div className="col-md-2 col-sm-12">
                                                <FormGroup>
                                                    <Label for="user_type">User Type* </Label>
                                                    <select name="userType" className="form-control"
                                                            value={this.state.userType}
                                                            onChange={this.changeUserType.bind(this)}
                                                    disabled={this.state.disableInput}>
                                                        <option value="">Select</option>
                                                        <option value="Internal">Internal</option>
                                                        <option value="External">External</option>

                                                    </select>
                                                    {this.validator.message('userType', this.state.userType, 'required')}
                                                </FormGroup>
                                            </div> : null }

                                        <div className="col-md-3 col-sm-12">
                                            <FormGroup>
                                                <Label for="userGroup">User Group* </Label>
                                                <select id="adduserGroup" name="userGroup" className="form-control"
                                                        value={this.state.userGroup}
                                                        onChange={this.changeUserGroups.bind(this,'','')}
                                                        disabled={this.state.disableInput}>
                                                    {this.state.group_select===true?
                                                        <option value=" ">Select</option> : null }
                                                    {allgroups}
                                                </select>
                                                {this.validator.message('userGroup', this.state.userGroup, 'required')}
                                            </FormGroup>
                                        </div>

                                        <div className="col-md-3 col-sm-12">
                                            <FormGroup>
                                                <Label for="userSubGroup">User Sub Group* </Label>
                                                <select name="userSubGroup" className="form-control"
                                                        value={this.state.userSubGroup}
                                                        onChange={this.changeUserSubGroups.bind(this)}
                                                        disabled={this.state.disableInput}>
                                                    <option value=" ">Select</option>
                                                    {allSubgroups}
                                                </select>
                                                {this.validator.message('userSubGroup', this.state.userSubGroup, 'required')}
                                            </FormGroup>

                                        </div>
                                        {this.state.luser_type == 'Internal' && this.state.lsub_group == 'Admin'?
                                        <React.Fragment>
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label className="text-center full-width">User Admin Access</label>
                                            <div className="alignedCenter">
                                                <div className="btn-group">
                                                    <button className={vcls} type="button" value="volume" onClick={this.change_user_admin_access.bind(this, true)} disabled={this.state.disableInput}>Yes </button>
                                                    <button className={ccls} type="button" value="count" onClick={this.change_user_admin_access.bind(this, false)} disabled={this.state.disableInput}>No </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label className="text-center full-width">User Approval Access</label>
                                            <div className="alignedCenter">
                                                <div className="btn-group">
                                                    <button className={vclsa} type="button" value="volume" onClick={this.change_user_approval_access.bind(this, true)} disabled={this.state.disableInput}>Yes </button>
                                                    <button className={cclsa} type="button" value="count" onClick={this.change_user_approval_access.bind(this, false)} disabled={this.state.disableInput}>No </button>
                                                </div>
                                            </div>
                                        </div>
                                        </React.Fragment>
                                        :null}
                                    </div>
                                    <div className="ro-sep"></div>
                                    <h5>User Details</h5>
                                    <div className="row">
                                        <div className="col-md-2 col-sm-12">
                                            <FormGroup>
                                                <Label for="password">Title*</Label>
                                                <select name="contact_title" className="form-control"
                                                        value={this.state.contact_title} onChange={this.changeTitle.bind(this)} disabled={this.state.disableInput}>
                                                    <option value=" ">Select</option>
                                                    <option value="Mr">Mr</option>
                                                    {/*<option value="Mrs">Mrs</option>*/}
                                                    <option value="Ms">Ms</option>

                                                </select>
                                                {this.validator.message('contact_title', this.state.contact_title, 'required')}
                                            </FormGroup>
                                        </div>
                                        <div className="col-md-6 col-xs-12">
                                            <FormGroup>
                                                <Label for="firstName">First Name*</Label>
                                                <Input id="firstName" name="firstName" value={this.state.firstName}
                                                       onChange={this.onChangeInput.bind(this)} disabled={this.state.disableInput}/>
                                                {this.validator.message('firstName', this.state.firstName, 'required')}
                                            </FormGroup>
                                        </div>

                                        <div className="col-md-4 col-xs-12">
                                            <FormGroup>
                                                <Label for="lastName">Last Name</Label>
                                                <Input id="lastName" name="lastName" value={this.state.lastName}
                                                       onChange={this.onChangeInput.bind(this)} disabled={this.state.disableInput}/>
                                                {/*{this.validator.message('lastName', this.state.lastName, 'required')}*/}
                                            </FormGroup>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 col-sm-12">
                                            <FormGroup>
                                                <Label for="eamil">Email*</Label>
                                                <Input id="email" name="email" autoComplete="new-password" value={(this.state.email).trim()} onChange={this.onChangeInput.bind(this)}  placeholder="Email address" disabled={this.state.disableInput}/>
                                                {this.validator.message('email', (this.state.email).trim(), 'required|email')}
                                            </FormGroup>
                                        </div>
                                        <div className="col-md-6 col-sm-12">
                                            <FormGroup>
                                                <Label for="phone">Phone</Label>
                                                <Input type="tel" id="phone" name="phone" autoComplete="new-password" value={this.state.phone} placeholder="10 digit mobile number"
                                                       pattern="[0-9]*" onChange={this.onChangeInputPhone.bind(this)} disabled={this.state.disableInput}/>

                                                {/*{this.validator.message('phone', this.state.phone, 'required|phone')}*/}
                                            </FormGroup>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {config.get('API_URL')!='https://sparcs.innoviti.com/api/node'?
                                            <div>
                                                <div className="col-md-6 col-sm-12">
                                                    <FormGroup>
                                                        <Label for="password">Password*</Label>
                                                        <Input id="password" name="password" type="password" autoComplete="new-password"
                                                               value={this.state.password}
                                                               onChange={this.onChangeInput.bind(this)} disabled={this.state.disableInput}/>

                                                        {passwordError}
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-6 col-sm-12">
                                                    <FormGroup>
                                                        <Label for="confirm_password">Confirm Password*</Label>
                                                        <Input
                                                            label={!this.validator.fieldValid('confirm_password') && 'Passwords need to match!'}
                                                            name='confirm_password'
                                                            type='password'
                                                            autoComplete="new-password"
                                                            value={this.state.confirm_password}
                                                            onChange={this.onChangeInput.bind(this)} disabled={this.state.disableInput}/>

                                                        {confirmPasswordError}
                                                    </FormGroup>
                                                </div>
                                            </div>
                                            : null
                                        }
                                    </div>
                                    {this.state.userType=='Internal' || this.state.object_type=='DMS' || this.state.object_type=='Lounge'?
                                        <div className="row">
                                            <div className="col-md-6 col-sm-12">
                                                <FormGroup>
                                                    <Label for="userGroup">Tableau User </Label>
                                                    <select id="tableau_user" name="tableau_user" className="form-control"
                                                            value={this.state.tablueUserName}
                                                            onChange={this.changeTableauUser.bind(this)}
                                                            disabled={this.state.disableInput}>
                                                            <option value=" ">Select One</option>
                                                        {tableauUsers}
                                                    </select>

                                                </FormGroup>
                                            </div>
                                            <div className="col-md-6 col-sm-12">
                                                <FormGroup>
                                                    <Label for="userGroup">Department </Label>
                                                    <select id="tableau_user" name="department" className="form-control"
                                                            value={this.state.user_department}
                                                            onChange={this.changeDepartment.bind(this)}
                                                            disabled={this.state.disableInput}>
                                                            <option value="">Select Department</option>
                                                        {departments}
                                                    </select>

                                                </FormGroup>

                                            </div>
                                        </div> : null }
                                    <div className="ro-sep"></div>
                                    <div className="row">
                                        {this.state.logged_user_type == 'Internal'?
                                        <div className="col-md-6 col-sm-12">
                                            <FormGroup>
                                                <Label for="login_type" className="d-block">Login Type</Label>
                                                &nbsp;&nbsp;<input type="radio" name="login_type"
                                                                   value="Standard"
                                                                   checked={this.state.login_type === 'Standard'}
                                                                   onChange={this.onLoginTypeChanged} disabled={this.state.disableInput}/> &nbsp; UnipayNext
                                                &nbsp;&nbsp;<input type="radio" name="login_type"
                                                                   value="DIY"
                                                                   checked={this.state.login_type === 'DIY'}
                                                                   onChange={this.onLoginTypeChanged} disabled={this.state.disableInput}/> &nbsp; DIY
                                                &nbsp;&nbsp;<input type="radio" name="login_type"
                                                                   value="Total EMI"
                                                                   checked={this.state.login_type === 'Total EMI'}
                                                                   onChange={this.onLoginTypeChanged} disabled={this.state.disableInput}/> &nbsp; Total EMI

                                            </FormGroup>
                                        </div> :null }
                                        {this.state.userType=='Internal' && config.get('API_URL')!='https://sparcs.innoviti.com/api/node'?

                                            <div className="col-md-6 col-sm-12">
                                                <FormGroup>
                                                    <Label for="auth_type" className="d-block">Auth Type</Label>
                                                    &nbsp;&nbsp;<input type="radio" name="auth_type"
                                                                       value="Google"
                                                                       checked={this.state.auth_type === 'Google'}
                                                                       onChange={this.onAuthTypeChanged} disabled={this.state.disableInput}/> &nbsp; Google
                                                    &nbsp;&nbsp;<input type="radio" name="auth_type"
                                                                       value="Normal"
                                                                       checked={this.state.auth_type === 'Normal'}
                                                                       onChange={this.onAuthTypeChanged} disabled={this.state.disableInput}/> &nbsp; Normal
                                                </FormGroup>
                                            </div>
                                            :null }
                                    </div>
                                    {this.state.action_type=='Edit User'?
                                        <div className="row">
{/*                                             <div className="col-md-12"> */}
{/*                                                 &nbsp; <input type="checkbox" name="send_mail" onChange={this.handleCheck.bind(this)} checked={(this.state.send_mail)? true : false} /> &nbsp; Resend activation mail */}
{/*                                             </div> */}
                                        </div> : null }


                                        <div>
                                            <div className="ro-sep"></div>
                                            {this.state.userType=='External'?
                                            <h5>
                                                Additional Data
                                            </h5> : null}
                                            <div className="row">
                                            <div className="col-md-12">{re_status}</div>
                                            {this.state.userType=='External' || this.state.userSubGroupName==='GENIE Sales Team'?
                                                <div className="col-md-6 col-sm-12">
                                                    {this.state.objectType=='Acquiring Bank'?
                                                        <FormGroup>
                                                            <Label for="org">Organization* </Label>
                                                            <ReactMultiSelectCheckboxes id="idOrganization" name="Organization"
                                                                                        autoComplete="new-password"
                                                                                        isMulti
                                                                                        components={{ MenuList }}
                                                                                        value={this.state.organization}
                                                                                        styles={customStyles} className="report-listbox"
                                                                                        isClearable={false}
                                                                                        onChange={this.onBankChange.bind(this)}
                                                                                        options={this.state.organizationList}
                                                                                        placeholderButtonLabel="Select [Organization]"
                                                                                        isDisabled={this.state.disableInput}
                                                            />
                                                        </FormGroup>:
                                                        <div>
                                                            <label> Organization:</label>
                                                            <div className="dd-wrapper">
                                                                <div className={orgClass} onClick={() => this.orgToggleList(this.state.disableInput)}>
                                                                    {this.state.object_code==''?
                                                                        <div className="dd-header-title">{this.state.orgHeaderTitle}</div>:
                                                                        <div className="dd-header-title">{this.state.object_code.length} Selected</div>
                                                                    }
                                                                    {this.state.orgListOpen===false?
                                                                        <i className="fa fa-angle-down"></i>:
                                                                        <i className="fa fa-close" style={{fontSize:"12px"}}></i>
                                                                    }

                                                                </div>
                                                                {this.state.orgListOpen ===true?
                                                                    <div
                                                                        role="list"
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        <input
                                                                            className="dd-list-search-bar-org"
                                                                            placeholder="Search"
                                                                            onChange={(e) => this.orgFilterList(e)}
                                                                        />
                                                                        <i className="fa fa-search" style={{position:"absolute", right:"5px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                                                                        {/*<div className="dd-scroll-list">*/}
                                                                        <ul className="dd-list-org">
                                                                            {this.state.is_org_loading===true?
                                                                                <li>
                                                                                    <BeatLoader
                                                                                        css={override}
                                                                                        sizeUnit={"px"}
                                                                                        size={5}
                                                                                        color={'#666666'}
                                                                                        loading={this.state.is_org_loading}
                                                                                    />
                                                                                </li>: null}
                                                                            {orgn_lists}

                                                                        </ul> </div>: null }
                                                                {/*</div>*/}
                                                            </div>
                                                            {this.state.disableInput===true?
                                                            <div style={{fontSize:"10px", fontWeight:"bold"}}>Organization Code: {this.state.object_code!=''?this.state.object_code.join(', '):''}</div>:null}
                                                        </div> }

                                                    {/*</div>*/}


                                                    <div className="clearfix"></div>
                                                </div> :null}
                                                {this.state.userType=='External'?
                                                <div className="col-md-6 col-xs-12">
                                                    <FormGroup>
                                                        <Label for="Designation">Designation</Label>
                                                        <Input id="Designation" name="designation" value={this.state.designation}
                                                               onChange={this.onChangeInput.bind(this)} disabled={this.state.disableInput}/>

                                                    </FormGroup>
                                                </div>:null}

                                            </div>
                                            {this.state.userType=='External'?
                                            <div className="row">
                                                <div className="col-md-6 col-xs-12">
                                                    <FormGroup>
                                                        <Label for="Account_Expiry_Date">Account Expiry Date</Label>
                                                        <DatePicker
                                                            dateFormat="yyyy-MM-dd"
                                                            selected={Date.parse(this.state.account_expiry_date)}
                                                            onChange={this.handleFromChange}
                                                            minDate={new Date()}
                                                            disabled={this.state.disableInput}
                                                        />

                                                    </FormGroup>
                                                </div>

                                                <div className="col-md-6 col-xs-12">
                                                    <FormGroup>
                                                        <Label for="upload">Upload Onboarding Document</Label>
                                                        <input type="file" name="file" className="form-control-file" onChange={this.onChangeHandler} disabled={this.state.disableInput}/>
                                                        {this.state.action_type=='Edit User' || this.state.action_type=='Activate User' || this.state.action_type=='Edit Request'?
                                                            <a href="#"  onClick={this.downloadDocFile.bind(this)}>{this.state.edit_file}</a>: null}


                                                    </FormGroup>
                                                </div>
                                            </div>: null }
                                        </div>

                                </ModalBody>
                                <ModalFooter>
                                    <div className="col-md-6 pull-left text-left">
                                        Fields marked with * are mandatory
                                    </div>
                                    <div className="col-md-6">
                                        {this.state.action_type == 'Add New User'?
                                            <Button color="primary" onClick={this.addUser.bind(this)}>Add User</Button>
                                            : null }
                                        {this.state.action_type == 'Edit User'?
                                            <React.Fragment>
                                            <Button color="primary" onClick={this.updateUser.bind(this,'')}>Edit User</Button>&nbsp;&nbsp;
                                            <Button color="primary" onClick={this.updateUser.bind(this,'1')}>Resend activation mail</Button>
                                            </React.Fragment>
                                            : null }
                                        {this.state.action_type== 'Activate User' ?
                                            <Button color="primary" onClick={this.approveUser.bind(this)}>Approve</Button>
                                            : null }
                                        {this.state.action_type == 'Edit Request'?
                                            <React.Fragment>
                                                <Button color="primary" onClick={this.updateUser.bind(this,'')}>Approve</Button>
                                                <Button color="primary" onClick={this.updateUser.bind(this,'2')}>Reject</Button>
                                            </React.Fragment>
                                            : null }
                                        {this.state.action_type == 'Delete Request'?
                                        <React.Fragment>
                                            <Button color="primary" onClick={this.updateUser.bind(this,'')}>delete</Button>
                                            <Button color="primary" onClick={this.updateUser.bind(this,'3')}>Reject</Button>
                                        </React.Fragment>
                                        : null }
                                        <Button color="secondary"
                                                onClick={this.toggleNewUserModel.bind(this)}>Cancel</Button>


                                    </div>
                                </ModalFooter>
                            </Modal>



                            <div className="card">
                                <div className="header">
                                    <div className="col-md-10 col-xs-6">
                                        <h4 className="title">Users</h4>
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                                <div className="">
                                    {this.state.logged_user_type == 'Internal'?
                                        <div className="col-md-2 col-sm-12">
                                            <FormGroup>
                                                <Label for="user_type">User Types</Label>
                                                <select name="userType" className="form-control"
                                                        value={this.state.filter_userType}
                                                        onChange={this.changeFilterUserType.bind(this)}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="Internal">Internal</option>
                                                    <option value="External">External</option>

                                                </select>

                                            </FormGroup>
                                        </div> : null }
                                    {this.state.filter_userType=='External' || this.state.filter_userType==''?
                                        <React.Fragment>
                                            <div className="col-md-2 col-sm-12">
                                                <FormGroup>
                                                    <Label for="userGroup">User Groups</Label>
                                                    <select id="adduserGroup" name="userGroup" className="form-control"
                                                            value={this.state.userFilterGroup}
                                                            onChange={this.changeUserFilterGroups.bind(this)}
                                                    >
                                                        {/*{this.state.group_select===true?*/}
                                                            <option value=" ">Select</option>
                                                        {/*: null }*/}
                                                        {allgroups}
                                                    </select>

                                                </FormGroup>
                                            </div>

                                            <div className="col-md-2 col-sm-12">

                                                <FormGroup>
                                                    <Label for="org">Organization</Label>
                                                    <ReactMultiSelectCheckboxes id="idOrganization" name="Organization"
                                                                                autoComplete="new-password"
                                                                                isMulti
                                                                                components={{ MenuList }}
                                                                                value={this.state.filterOrganization}
                                                                                styles={customStyles} className="report-listbox"
                                                                                isClearable={false}
                                                                                onChange={this.onFilterOrganizationchange.bind(this)}
                                                                                options={this.state.organizationFilterList}
                                                                                placeholderButtonLabel="Select [Organization]"
                                                    />
                                                </FormGroup>
                                            </div>
                                            </React.Fragment>:null }
                                    <div className="col-md-2 col-sm-12">

                                        <FormGroup>
                                            <Label for="sta">Status</Label>
                                            <ReactMultiSelectCheckboxes id="sta" name="sta"
                                                                        autoComplete="new-password"
                                                                        isMulti
                                                                        components={{ MenuList }}
                                                                        value={this.state.statusValue}
                                                                        styles={customStyles} className="report-listbox"
                                                                        isClearable={false}
                                                                        onChange={this.changeUserStatus.bind(this)}
                                                                        options={this.state.statusLists}
                                                                        placeholderButtonLabel="Select [Status]"
                                            />
                                        </FormGroup>

                                    </div>
                                    <div className="col-md-3 filter-bottom5 padd-5 pull-right">
                                        <div className="gap20"></div>
                                        <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this._refreshUsers.bind(this)}>Apply</button>
                                        &nbsp; &nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        <div>
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="clearfix"></div>
                                <div className="ro-sep"></div>
                                <div className="col-md-12">
                                    <div className="col-md-10 col-xs-6"></div>
                                    <div className="col-md-4 pull-right col-xs-6 addIcon">

                                        <a href="#" className="addButton" role="button"
                                           onClick={this.toggleNewUserUpload.bind(this, 'Add')}><span
                                            className="glyphicon glyphicon-upload" aria-hidden="true"></span>Import Users</a>&nbsp;&nbsp;
                                        <a href="#" className="addButton" role="button"
                                           onClick={this.toggleNewUserModel.bind(this, 'Add')}><span
                                            className="glyphicon glyphicon-plus" aria-hidden="true"></span>Add User</a>
                                    </div>
                                </div>
                                <div className="content table-full-width table-responsive mt-0">
                                    <NotificationSystem ref="notificationSystem" style={style}/>
                                    <div className='sweet-loading userFixed'>
                                        <BeatLoader
                                            css={override}
                                            sizeUnit={"px"}
                                            size={20}
                                            color={'#123abc'}
                                            loading={this.state.loading}
                                        />
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downLoadUserReport.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <table className="table table-striped table-hover" id="userTable">
                                        <thead>
                                        <tr>
                                            {/*<th>Sr No.</th>*/}
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>User Types</th>
                                            <th>User Groups</th>
                                            <th>Sub Groups</th>
                                            <th>Organization</th>
                                            <th>Status</th>
                                            <th>Comments</th>
                                            <th>Action</th>
                                            <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {/*{users}*/}
                                        </tbody>
                                    </table>
                                    <Modal isOpen={this.state.newOrgModel} toggle={this.toggleNewOrgModel.bind(this)} >
                                        <ModalHeader toggle={this.toggleNewOrgModel.bind(this)}>Organizations</ModalHeader>
                                        <ModalBody>
                                            <div className="issue_container">
                                                {this.state.all_orgs}
                                            </div>
                                        </ModalBody>
                                        <ModalFooter>

                                            <Button color="secondary" onClick={this.toggleNewOrgModel.bind(this)}>Cancel</Button>
                                        </ModalFooter>
                                    </Modal>
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        <p>Generating CSV...</p>
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default UserList;
